import {
  Breadcrumb as AntBreadcrumb,
  BreadcrumbProps as AntBreadcrumbProps,
} from "antd";
import AntBreadcrumbItem from "antd/lib/breadcrumb/BreadcrumbItem";
import { Children, isValidElement, ReactElement } from "react";

type Props = AntBreadcrumbProps & {
  wrapperClassname?: string;
  wrap?: boolean;
};

export const Breadcrumb: React.FC<Props> & {
  Item: typeof AntBreadcrumbItem;
} = ({
  children,
  className,
  itemRender,
  params,
  separator,
  wrapperClassname,
}) => {
  const items = Children.toArray(children)
    .filter(isValidElement)
    .map((child, index) => {
      const p = (child as ReactElement<any>).props;
      return {
        key: (child as ReactElement).key ?? index,
        title: p.children,
        onClick: p.onClick,
        className: p.className,
        href: p.href,
      };
    });

  return (
    <div className={wrapperClassname}>
      <AntBreadcrumb
        separator={separator}
        className={className}
        params={params}
        itemRender={itemRender}
        items={items}
      />
    </div>
  );
};

Breadcrumb.Item = AntBreadcrumbItem;
